// extracted by mini-css-extract-plugin
export var modalFooter = "_pr-0";